import React, { Component } from 'react'
import PlacesAutocomplete from 'react-places-autocomplete'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { string, func, bool } from 'prop-types'
import { cssClasses, options } from './InputOptions'
import {
  getSigns,
  convertAddressToCenter,
  handleFilterSearchHistory,
} from '../../store/Actions'
import {
  updateAddress,
  updateAddressCache,
} from '../../store/Actions/SignsActions'
import { addressBasedSearch } from '../../store/Actions/MapActions'
import AutoCompleteItems from './AutoCompleteItems'
import './styles/PlacesAutoComplete.css'

class AddressSearch extends Component {
  state = {
    address: '',
  }

  stripWhiteSpaces = address => address.replace(/\s\s+/g, ' ')

  handleGetSigns = async _address => {
    let address = this.stripWhiteSpaces(_address)
    this.setState({ address })
    this.props.updateAddress(address)
    this.props.updateAddressCache(address)
    await this.props.convertAddressToCenter(address)
    this.addressSearchInput.blur()
    this.props.addressBasedSearch(true)
    this.props.history.push(
      `/${this.props.center[0]}:${
        this.props.center[1]
      }/${this.props.category.join(',')}/${this.props.radius}`
    )
  }

  handleFocus = e => {
    e.target.select()
  }

  handleSearch = e => {
    let address = this.stripWhiteSpaces(e)
    this.setState({ address })
    this.props.updateAddress(address)
    this.props.handleFilterSearchHistory(address)
  }

  render() {
    const inputProps = {
      ref: input => {
        this.addressSearchInput = input
      },
      type: 'search',
      value: this.state.address,
      onChange: this.handleSearch,
      autoFocus: true,
      onFocus: this.handleFocus,
      placeholder: 'Start searching..',
      name: 'autocomplete__input',
      id: 'input-id',
    }
    return (
      <PlacesAutocomplete
        ref="search"
        id="mapSearchInput"
        onSelect={address => this.handleGetSigns(address)}
        renderSuggestion={AutoCompleteItems}
        onEnterKeyDown={address => this.handleGetSigns(address)}
        classNames={{
          ...cssClasses,
          autocompleteContainer: `${
            this.props.inHistory
              ? 'autocomplete-container hidden'
              : 'autocomplete-container'
          }`,
        }}
        inputProps={inputProps}
        options={options}
        highlightFirstSuggestion={false}
      />
    )
  }
}

AddressSearch.propTypes = {
  address: string.isRequired,
  addressCache: string.isRequired,
  updateAddress: func.isRequired,
  addressBasedSearch: func.isRequired,
  inHistory: bool.isRequired,
}

const mapStateToProps = ({ signsState, map, spi }) => ({
  address: signsState.address,
  addressCache: signsState.addressCache,
  center: map.center,
  radius: map.radius,
  category: spi.category,
  inHistory: signsState.filterSearchHistory.length > 0,
})

const mapDispatchToProps = dispatch => ({
  updateAddress: address => dispatch(updateAddress(address)),
  updateAddressCache: address => dispatch(updateAddressCache(address)),
  getSigns: () => dispatch(getSigns()),
  convertAddressToCenter: address => dispatch(convertAddressToCenter(address)),
  addressBasedSearch: value => dispatch(addressBasedSearch(value)),
  handleFilterSearchHistory: value =>
    dispatch(handleFilterSearchHistory(value)),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddressSearch)
)



// WEBPACK FOOTER //
// ./src/components/PlacesAutoComplete/index.jsx